import React, {useState} from "react";
import {Link} from "react-router-dom";
import HeaderRight from "../layouts/HeaderRight";
import { withTranslation } from 'react-i18next';
import CheckinPopup from "../timeregistration/CheckinPopup";
import ProjectOverview from "./ProjectOverview"
import ProjectTask from "./ProjectTask"
import ProjectActivity from "./ProjectActivity"

function ProjectDetails(props){
	const [taskLoad, setTaskLoad] = useState(true);
	const [activityLoad, setActivityLoad] = useState(false);
	const [overviewLoad, setOverviewLoad] = useState(false);

	const overviewOnLoad = () => {
		setOverviewLoad(true);
		setTaskLoad(false);
		setActivityLoad(false);
	}
	const tasakOnLoad = () => {
		setOverviewLoad(false);
		setTaskLoad(true);
		setActivityLoad(false);
	}
	const filesOnLoad = () => {
		setOverviewLoad(false);
		setTaskLoad(false);
		setActivityLoad(true);
	}

	const changeCheckIn = (checkInStatus) => {
        // this.setState({checkInStatus: checkInStatus});
    }

	return(
		<>
		<div className="header-area project-overview-page" style={{'borderRadius': 0}}>
			<div className="container">
                <div className="row">
                    <div className="col-sm-3 col-3">
                        <Link className="menu-back-page home-clicked" to={'/'}>
                            <i className="fa fa-home" />
                        </Link>
                    </div>
                    <div className="col-sm-6 col-6 text-center">
                        <div className="page-name">Project</div>
                    </div>
                    <div className="col-sm-3 col-3 text-right">
                       <HeaderRight />
                    </div>
                </div>
            </div>
		</div>
        <div className="mg-top-30 sub-header"></div>

        <div className='project-overview-page transaction-area mg-bottom-40'>
	        <ul className="nav nav-tabs" id="example-one" role="tablist">
	            <li className="nav-item">
	                <a onClick={tasakOnLoad} className="nav-link active" id="base-tab-2" data-toggle="tab" href="#tab-2" role="tab" aria-controls="tab-2" aria-selected="false">Tasks</a>
	            </li>
	            <li className="nav-item">
	                <a onClick={filesOnLoad} className="nav-link" id="base-tab-3" data-toggle="tab" href="#tab-3" role="tab" aria-controls="tab-3" aria-selected="false">Activity</a>
	            </li>
	            <li className="nav-item">
	                <a onClick={overviewOnLoad} className="nav-link" id="base-tab-1" data-toggle="tab" href="#tab-1" role="tab" aria-controls="tab-1" aria-selected="true" >Overview</a>
	            </li>
	        </ul>

        	{/* Page will be show here */}
        	{(overviewLoad) ?
        		<ProjectOverview project_id={props.match.params.id}/>
        	: ''}

        	{(taskLoad) ?
        	<ProjectTask project_id={props.match.params.id}/>
        	: ''}

        	{(activityLoad) ?
        	<ProjectActivity project_id={props.match.params.id}/>
        	: ''}

        	{/* Page will be show here */}

        </div>
        {/* transaction End */}

        {/* Footer start */}
        <div className="footer-area">
            <div className="container">
                <div className="footer-bottom text-center">
                    <div className="row center">
                       <div className="col-8 offset-2 center">
                            
                        </div>
                        <div className="col-2">
                            <Link className="home-clicked" to={'/project-list'}>
                                <i className="fa fa-reply" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* Footer End */}
        {/* Check in popip end  */}
            <CheckinPopup setCheckInStatus = {changeCheckIn}  checkinoutScreen="time" p_userid={localStorage.getItem('userid')}/>
        {/* Checkin popup end  */}
        </>
	);
}

export default ProjectDetails;